<div fxLayout="row" fxLayoutAlign="start start">
	<div fxFlex>
		<h2 i18n="@@donations_zero_donation_heading">Donations</h2>
	</div>
	<div class="cursor-pointer">
		<button mat-icon-button (click)="scrollToDonation()">
			<img
				src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/capsLock/public"
			/>
		</button>
	</div>
</div>

<div fxLayout="row" fxLayoutAlign="start baseline">
	<div fxFlex>
		<div id="donationAmount" class="mat-h1">
			<app-amount-view
				[fundraiserCardData]="fundraiserCardData"
				[offlineDonationAmount]="totalOfflineDonationAmount"
			></app-amount-view>
		</div>
	</div>
</div>

<div *ngIf="fundraiserCardData.showDonationAmount">
	<app-donation-progress-bar
		class="m-b-m"
		[fundraiserCardData]="fundraiserCardData"
		[offlineDonationAmount]="totalOfflineDonationAmount"
	></app-donation-progress-bar>
</div>

<div fxLayout="row" fxFill fxLayoutAlign="start center">
	<div fxLayout="column" fxFlex="50%" fxLayoutAlign="center start">
		<h3 id="fundedPercentage">
			<app-days-left-view
				[fundraiserCardData]="fundraiserCardData"
			></app-days-left-view>
		</h3>
	</div>
	<div fxLayout="column" fxFlex="50%" fxLayoutAlign="center end">
		<h3 id="fundedPercentage">
			<app-donation-progress-percentage
				[fundraiserCardData]="fundraiserCardData"
				[showLabel]="true"
				[offlineDonationAmount]="totalOfflineDonationAmount"
			></app-donation-progress-percentage>
		</h3>
	</div>
</div>

<div
	[matTooltip]="donationToolTipMessage"
	[matTooltipDisabled]="!isDraftOrClosed"
>
	<button
		id="donateButton"
		mat-flat-button
		color="accent"
		[disabled]="
			isDraftOrClosed || isOpen == false || isLoading || !chargesEnabled
		"
		(click)="donate()"
		[style.color]="'#fff'"
		class="w-100"
	>
		<span i18n="@@button_donate"> Donate</span>
		<mat-icon *ngIf="isLoading" class="m-l-xs">
			<mat-spinner color="accent" diameter="16"> </mat-spinner>
		</mat-icon>
	</button>
</div>
